import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnChanges,
    OnInit, SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow, MatRowDef, MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatMenu, MatMenuPanel, MatMenuTrigger} from "@angular/material/menu";
import {MatOption} from "@angular/material/autocomplete";
import {MatPaginator} from "@angular/material/paginator";
import {MatSelect} from "@angular/material/select";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatTooltip} from "@angular/material/tooltip";
import {CookieService} from "ngx-cookie-service";
import {DialogService} from "../../_modal/dialog.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomizerSettingsService} from "../../../customizer-settings/customizer-settings.service";
import {OverlayContainer} from "@angular/cdk/overlay";
import {HandleErrorsService} from "../../../services/handle-erros/handle.errors.service";
import {environment} from "../../../../environments/environment";
import {RapportService} from "../../../services/rapport-service/rapport.service";
import {Endpoints} from "../../endpoints";
import { finalize, Observable, tap } from 'rxjs';
import { SampleService } from '../../../services/sample-service/sample.service';
import { LotDto } from '../../_models/LotDto';
import { LotService } from '../../../services/lot-service/lot.service';
import { ClientsService } from '../../../services/client-service/clients.service';
import { ShortClientDto } from '../../_models/client.dtos';
import { UserService } from '../../../services/user-service/user.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SamplerListComponent } from '../manage-samplers/sampler-list/sampler-list.component';
import { SignatureComponent } from '../../../signature/signature.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-report',
    standalone: true,
    providers: [DialogService, HandleErrorsService, RapportService, Endpoints],

    imports: [
        DatePipe,
SignatureComponent,
        FormsModule,
        MatButton,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatCell,
        MatCellDef,
        MatCheckbox,
        MatColumnDef,
        MatError,
        MatFormField,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatInput,
        MatLabel,
        MatMenu,
        MatOption,
        MatPaginator,
        MatRow,
        MatRowDef,
        MatSelect,
        MatSort,
        MatTable,
        MatTooltip,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        MatHeaderCellDef,
        MatMenuTrigger,
        RouterLink
    ], 
    templateUrl: './lot.component.html',
    styleUrl: './lot.component.scss'
})
export class LotComponent implements OnInit, OnChanges, AfterViewInit {
editModal: TemplateRef<LotDto>;
menu: MatMenuPanel<any>|null;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    Form: FormGroup;
    searchValue: string = '';
    devis?: LotDto;
    rapportId: number; // Ajout pour stocker l'ID du rapport sélectionné
    loadingDevis: boolean = false;
    dataSource: MatTableDataSource<LotDto> = new MatTableDataSource<LotDto>();
    selectedRapport: Set<LotDto> = new Set<LotDto>(); // Correction du nom
    isAllRapportSelected: boolean = false;
    sampleIds: number[] = [];  // Variable pour stocker les sampleIds associés au rapport


    displayedColumns: string[] = [
        'select',     
        'batchName',      
        'batchType',  
        'descriptif',    
        'numberOfSamples',    
        //'creationDate',            
        //'clientName', 
        'createdBy', 
        'commentaire',  
        'action'
    ];

    columns: string[] = [
        'select',
        'batchName',      
        'batchType',
        'descriptif',   
        'numberOfSamples',    
        //'creationDate',           
       // 'clientName', 
        'createdBy',
        'commentaire',    
        'action'
    ];
    
    loadingTable: boolean = true;
    loadingOT: boolean = false;
    loadingPdfGen: boolean = false;
    viewModal: TemplateRef<LotDto>;
    batchStatuses: any;

    constructor(
        private dialog: MatDialog,
        private router: Router,
        private cookieService: CookieService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private rapportService: RapportService,
        private lotService:LotService,
        private clientsService:ClientsService,
        private userService:UserService,
        private sampleService:SampleService,
        private handleErrors: HandleErrorsService,
        private endpoints: Endpoints,
        private http : HttpClient,
        private route: ActivatedRoute,
    
    ) {
        this.initializeForm();
    }

    lotId: string = '';


    ngOnInit() {
        this.fetchLotList();
        this.getColsCookie();
        this.fetchClientList();

    }

    

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource.filter = this.searchValue;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';
    }
    public lotSample :any;


    @ViewChild(SamplerListComponent) sampleComponent: SamplerListComponent; // Pour accéder à SampleComponent

    initializeForm() {
        this.Form = this.fb.group({
            id: [null],
            batchName: [null, [Validators.required, Validators.maxLength(100)]], // Nom du lot
            batchType: [null],
            descriptif: [null],
            commentaire: [null], // Type du lot
            //creationDate: [null, [Validators.required]], 
            clientId: [null, [Validators.required]], // Client
            numberOfSamples: [null, [Validators.required]], // Nombre d'échantillons
            createdBy: [null, [Validators.required]], // Utilisateur qui a créé
          });
    }

    selectedLot: LotDto | null = null;
updateBatch(): void {
  const updatedLot = this.Form.value;

  console.log("📝 Valeur du formulaire:", updatedLot);

  // Vérification du nombre d'échantillons
  if (!updatedLot.numberOfSamples || updatedLot.numberOfSamples <= 0) {
    console.error("⚠️ Nombre d'échantillons invalide:", updatedLot.numberOfSamples);
    return;
  }

  console.log("📦 Récupération du lot original pour comparaison...");

  this.lotService.getBatchById(updatedLot.id).subscribe({
    next: (originalLot) => {

      const originalNumberOfSamples = originalLot.numberOfSamples;
      const updatedNumberOfSamples = updatedLot.numberOfSamples;

      console.log(`🔎 Ancien: ${originalNumberOfSamples}`);
      console.log(`🔎 Nouveau: ${updatedNumberOfSamples}`);

      this.lotService.updateBatch(updatedLot.id, updatedLot).subscribe({
        next: (res) => {

          const batchId = res.id;

          this.modalService.dismissAll();
          this.dialogService.openSuccessDialog('Lot modifié avec succès.');
          this.fetchLotList();
          this.Form.reset();

          // ✅ فقط إذا تزاد العدد
          if (updatedNumberOfSamples > originalNumberOfSamples) {

            sessionStorage.setItem(
              'lastCreatedBatchId',
              batchId.toString()
            );

            sessionStorage.setItem(
              'openSampleAfterUpdate',
              'true'
            );

            this.router.navigate(['/manage-prelevemnt']);
          }
        },
        error: (err) => {
          console.error('❌ Erreur update lot:', err);
        }
      });
    },
    error: (err) => {
      console.error('❌ Erreur récupération lot:', err);
    }
  });
}

    
    openEditModal(element: LotDto, editModal: TemplateRef<LotDto>) {
        console.log('Edition du lot:', element);
        this.rapportId = element.id;
        this.Form.patchValue(element);
        this.cdr.detectChanges();
        this.modalService.open(editModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    }

    openViewModel(element: LotDto, viewModal: TemplateRef<LotDto>) {
        console.log('Affichage du rapport:', element);
        this.devis = element;
        this.cdr.detectChanges();
        this.modalService.open(viewModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    }

    openModal(content: any) {
    this.Form.reset(); 

    // Ouvrir le modal avec le contenu spécifié et la taille xl
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then(
      (result) => {
        if (result === 'save') {
          this.saveBatch(); // Appel à la méthode saveBatch pour enregistrer les données
        }
      },
      (reason) => {
        console.log("Modal fermé sans sauvegarde.");
      }
    );
    }


    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }
    downloadReport(batchId: number): void {
        this.lotService.downloadPdfByBatchId(batchId);
      }
      
      downloadCodeBarre(batchId: number): void {
        this.lotService.downloadPdfCodeBarre(batchId);
      }
    confirmDelete(element: any) {
        this.dialogService.open(
            "Êtes-vous sûr de vouloir supprimer ce lot ?",
            environment.warning_message_type,
            'danger',
            environment.warning_icon,
            true
        ).then((result: any) => {
            if (result) {
                this.deleteLot(element.id);
            }
        });
    }


  batchIds: number[] = []; // Liste des IDs des lots
  loadingRapport: boolean = false;
  loadingCodeBarre: boolean = false;
  rapportd = 317; // ID du rapport auquel la signature sera associée

  errorMessage: string = '';

  resizeSignatureBase64(base64Str: string): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const maxWidth = 300;  // largeur cible
      const maxHeight = 100; // hauteur cible
      let width = img.width;
      let height = img.height;

      // Garder les proportions
      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, width, height);

      // Retourne une image PNG redimensionnée
      const resizedBase64 = canvas.toDataURL('image/png');
      resolve(resizedBase64);
    };

    img.onerror = () => resolve(base64Str); // en cas d’erreur, on garde l’original
  });
}

openSignatureDialog() {
  console.log('Ouverture de la boîte de dialogue de signature...');

  const dialogRef = this.dialog.open(SignatureComponent, {
    width: '500px'
  });

  dialogRef.afterClosed().subscribe((signatureBase64: string) => {
    console.log('Boîte de dialogue fermée. Valeur reçue :', signatureBase64);

    if (signatureBase64) {
      console.log('Signature valide détectée.');

      // Redimensionner l'image ici
      this.resizeSignatureBase64(signatureBase64).then((resizedData) => {
        const signatureDTO = {
          rapportId: this.rapportd,
          signatureData: resizedData
        };

        console.log('Objet à envoyer au backend :', signatureDTO);

        this.lotService.saveSignature(signatureDTO).subscribe({
          next: (response) => {
            console.log('✅ Signature envoyée avec succès :', response);
          },
          error: (error) => {
            console.error('❌ Erreur lors de l\'envoi de la signature :', error);
          }
        });
      });
    } else {
      console.warn('Aucune signature reçue ou utilisateur a annulé.');
    }
  });
}


  // Service HTTP pour envoyer la signature au backend

  generateReportsForBatches() {
    this.loadingRapport = true;
    
    // Vérifier s'il y a des lots sélectionnés
    if (this.selectedRapport.size < 1) {
        console.log("❌ Aucun lot sélectionné !");
        this.dialogService.openDangerDialog('Aucun lot sélectionné');
        this.loadingRapport = false;  // Remettre l'état à "non chargé" si aucun lot n'est sélectionné
        return;
    }

    // Extraire les IDs des lots sélectionnés
    let batchIds: number[] = [];
    this.selectedRapport.forEach((rapport) => {
        batchIds.push(rapport.id);
    });

    console.log("📌 Lots sélectionnés :", this.selectedRapport);
    console.log("📌 IDs des lots envoyés au backend :", batchIds);

    // Appeler le service pour générer les rapports pour les lots
    this.lotService.generateReportsForBatches(batchIds).subscribe({
        next: (response: any) => {
            console.log("✅ Réponse reçue avec succès :", response);

            // Si la réponse contient des rapports
            if (response && response.length > 0) {
                response.forEach((base64String: string) => {
                    // Convertir la chaîne base64 en un objet Blob pour pouvoir télécharger le fichier
                    const blob = this.base64ToBlob(base64String, 'application/pdf');
                    const a = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = 'rapport.pdf';  // Vous pouvez personnaliser le nom du fichier si nécessaire
                    a.click();
                    window.URL.revokeObjectURL(url); // Libérer l'URL après téléchargement
                });

                // Remettre l'état du bouton à "non chargé" une fois le rapport généré et téléchargé
                this.loadingRapport = false;

            } else {
                // Si la réponse est vide ou mal formée
                console.error("❌ Aucun rapport trouvé dans la réponse.");
                this.dialogService.openDangerDialog('Aucun rapport trouvé.');
                this.loadingRapport = false;  // Remettre l'état du bouton en "non chargé" en cas d'erreur
            }
        },
        error: (err) => {
            console.error("❌ Erreur lors de la génération du rapport :", err);
            this.handleErrors.catchError(err);
            this.loadingRapport = false;  // Remettre l'état du bouton à "non chargé" en cas d'erreur
        }
    });
}

generateCodeBarreForBatches() {
    // Initialisation du bouton en mode "chargement"
    this.loadingCodeBarre = true;
    
    // Vérifier s'il y a des lots sélectionnés
    if (this.selectedRapport.size < 1) {
        console.log("❌ Aucun lot sélectionné !");
        this.dialogService.openDangerDialog('Aucun lot sélectionné');
        this.loadingCodeBarre = false;  // Remettre l'état à "non chargé" si aucun lot n'est sélectionné
        return;
    }

    // Extraire les IDs des lots sélectionnés
    let batchIds: number[] = [];
    this.selectedRapport.forEach((rapport) => {
        batchIds.push(rapport.id);
    });

    console.log("📌 Lots sélectionnés :", this.selectedRapport);
    console.log("📌 IDs des lots envoyés au backend :", batchIds);

    // Appeler le service pour générer les codes barres pour les lots
    this.lotService.generateCodeBarreForBatches(batchIds).subscribe({
        next: (response: any) => {
            console.log("✅ Réponse reçue avec succès :", response);

            // Si la réponse contient des codes barres
            if (response && response.length > 0) {
                response.forEach((base64String: string) => {
                    // Convertir la chaîne base64 en un objet Blob pour pouvoir télécharger le fichier
                    const blob = this.base64ToBlob(base64String, 'application/pdf');
                    const a = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = 'codes_barres.pdf';  // Nom du fichier modifié pour les codes barres
                    a.click();
                    window.URL.revokeObjectURL(url); // Libérer l'URL après téléchargement
                });

                // Remettre l'état du bouton à "non chargé" une fois les codes barres générés et téléchargés
                this.loadingCodeBarre = false;

            } else {
                // Si la réponse est vide ou mal formée
                console.error("❌ Aucun code barre trouvé dans la réponse.");
                this.dialogService.openDangerDialog('Aucun code barre généré.');
                this.loadingCodeBarre = false;  // Remettre l'état du bouton en "non chargé" en cas d'erreur
            }
        },
        error: (err) => {
            console.error("❌ Erreur lors de la génération des codes barres :", err);
            this.handleErrors.catchError(err);
            this.loadingCodeBarre = false;  // Remettre l'état du bouton à "non chargé" en cas d'erreur
        }
    });
}

base64ToBlob(base64: string, mimeType: string) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mimeType });
}

  

deleteLot(lotId: number): void {
    this.lotService.deleteBatch(lotId).subscribe({
      next: (response) => {
        console.log("Lot supprimé avec succès", response);
        this.dialogService.openSuccessDialog("Lot supprimé avec succès")
        this.fetchLotList()

     },
      error: (err) => {
        console.error("Erreur lors de la suppression du lot", err);
      }
    });
  }
  

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(rapport => rapport.id !== id);
        this.dataSource = new MatTableDataSource<LotDto>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource.filter = this.searchValue;
    }

// stocker les IDs des lots sélectionnés
selectedBatchIds: number[] = [];

handleSelection(rapport: LotDto) {
  if (this.selectedRapport.has(rapport)) {
    this.selectedRapport.delete(rapport);
    console.log(`Rapport avec ID ${rapport.id} a été désélectionné`);
  } else {
    this.selectedRapport.add(rapport);
    console.log(`Rapport avec ID ${rapport.id} a été sélectionné`);
  }

  // Mettre à jour la liste des batchIds sélectionnés
  this.selectedBatchIds = Array.from(this.selectedRapport).map(item => item.id);
  console.log('Batchs sélectionnés:', this.selectedBatchIds); // Affiche les IDs des lots sélectionnés
}

handleSelectAll() {
    this.isAllRapportSelected = !this.isAllRapportSelected;
    
    // Mettre à jour le Set des rapports sélectionnés
    this.selectedRapport = this.isAllRapportSelected
      ? new Set<LotDto>(this.dataSource.filteredData)
      : new Set<LotDto>();
    
    // Mettre à jour la liste des batchIds sélectionnés
    this.selectedBatchIds = this.isAllRapportSelected
      ? this.dataSource.filteredData.map(item => item.id)
      : [];
    
    console.log('Batchs sélectionnés:', this.selectedBatchIds);
  }
  

  onSelectionChange(column: string): void {
    if (this.displayedColumns.includes(column)) {
        // If the column is already selected, remove it from displayedColumns
        this.displayedColumns = this.displayedColumns.filter(c => c !== column);
    } else {
        // If the column is not selected, add it back to the original position
        const index = this.columns.indexOf(column);
        if (index !== -1) {
            this.displayedColumns.splice(index, 0, column); // Add the column at its original position
        }
    }
    this.setColsCookie();
}
handleIsAllColsSelected(event: MatCheckboxChange) {
    if (event.checked) {
        // Show all columns
        this.displayedColumns = [...this.columns];
    } else {
        // Hide all columns
        this.displayedColumns = [];
    }
    this.setColsCookie();
}
    getdisplayedCol = (): string[] => {
        return ['select', ...this.displayedColumns, 'action'];
    };

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`lotCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const reportCols = this.cookieService.get(`lotCol_${this.user_name}`);
        if (reportCols) {
            this.displayedColumns = JSON.parse(reportCols);
            console.log('Colonnes récupérées:', reportCols);
        }
    }


    clientList: ShortClientDto[]



    private fetchClientList() {
        this.clientsService.loadClients().subscribe({
            next: response => {
                if(response.status){
                    this.clientList = response.data
                }
            }
        })
    }

    getClientName(clientId: number): string {
        const client = this.clientList?.find(client => client.id === clientId);
        return client?.socialReason ?? 'N/A';  // Utilisation de l'opérateur "??" pour éviter "undefined"
    }

    saveBatch(): void {
        // Récupérer l'ID de l'utilisateur connecté depuis le sessionStorage
        const currentUserId = sessionStorage.getItem('user_id');
        if (!currentUserId) {
            return;
        }
    
    
        // Ajouter l'ID utilisateur au formulaire pour le champ createdBy
        this.Form.patchValue({ createdBy: Number(currentUserId) });    
        const newBatch = this.Form.value;
            console.log("Données envoyées pour création du lot:", newBatch);
    
        // Appel du service pour créer le lot
        this.lotService.createBatch(newBatch).subscribe({
            next: (batch) => {
                console.log('Lot créé avec succès:', batch);
                this.modalService.dismissAll();
                this.dialogService.openSuccessDialog('Lot crée avec succès.'); // Si tu fermes un modal après création
                this.fetchLotList(); // Pour rafraîchir la liste
                this.Form.reset(); 
                sessionStorage.setItem('lastCreatedBatchId', batch.id.toString());

                this.router.navigate(['/manage-prelevemnt']);
            
                setTimeout(() => {
                    this.lotService.requestOpenSampleModal(batch.id);
                }, 150);         
                },
            error: (err) => {
                console.error('Erreur lors de la création du lot:', err);
                this.handleErrors.catchError(err);
            }
        });
    }
    users: { [key: number]: string } = {};  // Dictionnaire pour stocker les noms d'utilisateur par ID

    fetchLotList(): void {
        this.loadingTable = true;
        console.log("Chargement des lots en cours...");
      
        this.lotService.getAllBatches().subscribe({
          next: (response: LotDto[]) => {
            console.log('Réponse reçue depuis l\'API:', response);
      
            this.dataSource.data = response.map((lot: LotDto) => {
              return { ...lot };
            });
      
            // Pour chaque lot, récupérer les infos du créateur
            this.dataSource.data.forEach(lot => {
              console.log("Traitement du lot avec createdBy:", lot.createdBy);      
              if (lot.createdBy) {
                this.userService.getUserById(lot.createdBy).subscribe({
                  next: (user) => {
                    lot.createdByUsername = user.username;
                  },
                  error: (err) => {
                    console.error(`Erreur lors de la récupération de l'utilisateur ID ${lot.createdBy}:`, err);
                  }
                });
              } else {
                console.warn("Aucun createdBy pour ce lot:", lot);
              }
            });
      
            this.loadingTable = false;
            console.log("Chargement des lots terminé.");
          },
          error: (err) => {
            this.handleErrors.catchError(err);
            console.error("Erreur lors de la récupération des lots:", err);
            this.loadingTable = false;
          }
        });
      }
      openSampleForm(): void {
        this.router.navigate(['/manage-samplers'], { queryParams:  { openForm: 'true' }  });
    }
}
